import clsx from "clsx";
import { type FC } from "react";

import { COURSE_GROUPING_ID_QUERY_PARAM, COURSE_ID_QUERY_PARAM } from "components/constants";
import { CourseType } from "components/server-types";
import { ListItem } from "mds/components/ListItem";
import { ADMIN_COURSE_EVENT_PREFIX } from "utils/amplitude";
import { getCourseDisplayTitle } from "utils/course";
import { useQueryParamsManager } from "utils/routing";
import { withQueryParams } from "utils/urls";

type CourseNavListItemProps = {
  className?: string;
  course: CourseType;
  isSelected: boolean;
};

export const CourseNavListItem: FC<CourseNavListItemProps> = ({
  course,
  className,
  isSelected,
}) => {
  const { setQueryParams } = useQueryParamsManager();

  return (
    <ListItem
      className={clsx("my-1 min-w-12 justify-between", className)}
      eventName={`${ADMIN_COURSE_EVENT_PREFIX}Course selected`}
      eventProperties={{ course: course.code }}
      isSelected={isSelected}
      label={getCourseDisplayTitle(course)}
      to={withQueryParams("", {
        [COURSE_ID_QUERY_PARAM]: course.id,
        // Passing null or "null" is equivalent because URLSearchParams will stringify null as "null"
        // We use "null" to avoid TypeScript's nullability check.
        [COURSE_GROUPING_ID_QUERY_PARAM]: "null",
      })}
      onClick={() => {
        setQueryParams({
          [COURSE_ID_QUERY_PARAM]: course.id,
          [COURSE_GROUPING_ID_QUERY_PARAM]: null,
        });
      }}
    >
      <div className="flex w-full min-w-12 items-center justify-between">
        <h3 className="body-s my-1 w-full min-w-12 cursor-pointer truncate font-medium">
          {getCourseDisplayTitle(course)}
        </h3>
      </div>
    </ListItem>
  );
};
